module.exports = __webpack_public_path__ + "img/leadsHold.9916fe6a.svg";